import React from 'react';
import {
  AttendeeFragment,
  InteractionForAttendeeFragment,
  InteractionFragment,
  PublicEWebinarFragment,
  ReactionFragment,
} from '$/GraphQL/schema/types';
import { Emoji } from 'emoji-mart';
import { InteractionInfo } from '../InteractionInfo';
import { AnalyticsCardProps } from '../cards/types';
import FeedBackCard from './FeedbackCard';
import { InteractionModalAccordionsHook, InteractionModalComponentProps } from '../types';

const FeedbackModal = React.lazy(() => import('./FeedbackModal'));
const AnalyticsFeedbackCard = React.lazy(() => import('./AnalyticsFeedbackCard'));

export class FeedbackInfo extends InteractionInfo {
  public constructor(
    i: InteractionForAttendeeFragment | InteractionFragment,
    ewebinar?: PublicEWebinarFragment,
    attendee?: AttendeeFragment
  ) {
    super(i, ewebinar, attendee);
  }

  public messageCardBody(
    reaction: Pick<
      ReactionFragment,
      'stringAnswer' | 'numberAnswer' | 'detailsFields' | 'arrayAnswer'
    >,
    _answerContent?: string
  ): JSX.Element | null {
    const emoji = ['sob', 'disappointed', 'neutral_face', 'smiley', 'star-struck'];
    const answer = reaction.numberAnswer || 0;
    const answerIcon = (
      <span className='mr-1e'>
        <Emoji emoji={emoji[answer - 1]} set='apple' size={23} />
      </span>
    );
    const cardBody = (
      <div>
        <div className='flex items-center'>
          {answerIcon}
          <div>{answer} / 5</div>
        </div>
        <div className='mt-1/2e text-sm'>{this.answerMessage(reaction)}</div>
      </div>
    );

    return cardBody;
  }

  public cardBodyComponent(): React.FC {
    return FeedBackCard;
  }

  public analyticsCardComponent(): React.LazyExoticComponent<React.FC<AnalyticsCardProps>> {
    return AnalyticsFeedbackCard;
  }

  public useModalPreviewComponent(): React.LazyExoticComponent<
    React.FC<InteractionModalComponentProps>
  > | null {
    return FeedbackModal;
  }

  public modalSettingsAccordions(): InteractionModalAccordionsHook | null {
    return null;
  }
}
